import { Outlet } from 'react-router-dom';
import NavBar from './NavBar';
import Footer from './Footer';
import InstallPrompt from './InstallPrompt';

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-background">
      <NavBar />
      <main className="pt-14 w-full">
        <Outlet />
      </main>
      <Footer />
      <InstallPrompt />
    </div>
  );
}